import {Icon, Text} from '@priority-software/priority-style-react';
import React from 'react';
import {ChartIcons, SingleSeriesChartTypesOptions} from '../../chartConsts';
import styles from '../styles.module.scss';
import texts from '../../../ReportGenerator/texts';
import {getChartLabelByType} from '../../utils';

const ChartTypeFolder = ({chartInfo}) => {
    const isSingleSeries = SingleSeriesChartTypesOptions[chartInfo.type];

    return (
        <div className={styles.chartTypeFold}>
            <Text wrap={false}>
                {!!isSingleSeries ? texts.singleSeries : texts.multiSeries}
                {' - '}
                {getChartLabelByType(chartInfo.type)}
            </Text>
            <Icon icon={ChartIcons[chartInfo.type]} componentClasses={styles.chartIconTab} />
        </div>
    );
};

export default ChartTypeFolder;
